import api from 'src/api';

export const loginStaff = async (data) => {
  try {
    return await api('/staff/login', data, 'post');
  } catch (err) {
    try {
      return await api('/login', data, 'post');
    } catch (docErr) {
      throw err || docErr;
    }
  }
};

export const getProfile = async () => {
  try {
    const res = await api('/staff/profile', null, 'get');
    if (res?.staff) return res;
    throw new Error('No staff profile');
  } catch (err) {
    try {
      const docRes = await api('/profile', null, 'get');
      if (docRes?.user) {
        return {
          staff: {
            id: docRes.user.id || docRes.user._id,
            name: docRes.user.personalInfo?.fullName || docRes.user.name || 'Doctor',
            email: docRes.user.loginInfo?.email || docRes.user.email,
            role: 'DOCTOR',
            status: 'ACTIVE',
            isDoctor: true,
          },
        };
      }
    } catch (docErr) {
      console.warn('Doctor profile fallback error:', docErr);
    }
    throw err;
  }
};

export const sendOtp = (data) => {
  return api('/staff/send-otp', data, 'post');
};

export const loginWithOtp = (data) => {
  return api('/staff/login-with-otp', data, 'post');
};

export const getClinics = async () => {
  try {
    const res = await api('/clinic/staff', null, 'get');
    if (res?.data && res.data.length > 0) return res;
    return await api('/clinic', null, 'get');
  } catch {
    try {
      return await api('/clinic', null, 'get');
    } catch (err) {
      throw err;
    }
  }
};
